import {Injectable} from '@angular/core';
import {ProgressCopySession} from './progress-copy-session';

const storageKey = 'nova-progress-copy-v1';
@Injectable({providedIn: 'root'})
export class ProgressCopyService {
  private session: ProgressCopySession;
  constructor() {
    let saved: unknown;
    try { saved = JSON.parse(sessionStorage.getItem(storageKey) ?? 'null'); } catch { /* Storage is optional. */ }
    this.session = new ProgressCopySession(saved, state => {
      try { sessionStorage.setItem(storageKey, JSON.stringify(state)); } catch { /* Keep rotating in memory. */ }
    });
  }
  createTurn() { return this.session.createTurn(); }
}
